<!--
 * @Author: M.D.
 * @Date: 2020-01-14 13:11:43
 * @LastEditors: M.D.
 * @Description:
 *
 * @Remarks:
 -->
<template>
  <div class="so-o-w" v-show="subOrderType !== -1" id="so-o-w">
    <!-- 收货地址 -->
    <div class="so-address-w" v-if="subOrderType !== 2">
      <div class="so-a-title">
        {{ subOrderType === 3 ? '收货地址' : '联系方式' }}
      </div>
      <div class="so-a-info">
        <div class="so-a-l">
          <div v-if="subOrderType === 3">
            <div class="add-item">
              收货人：{{ this.addInfo.receivingName || '' }}
            </div>
            <div class="add-item">
              收货电话：{{ this.addInfo.mobile || '' }}
            </div>
            <div class="add-item">
              收货地址：{{ this.addInfo.address || '' }}
            </div>
          </div>
          <div v-if="subOrderType === 1">
            <div class="phone-item">联系电话：{{ this.addInfo.mobile }}</div>
          </div>
        </div>
        <div class="so-a-r">
          <el-button
            v-if="subOrderType === 3"
            @click.native="showEditAdd = true"
            class="so-a-edit-btn"
            type="primary"
            slot="append"
          >
            编辑收货地址
          </el-button>

          <el-button
            v-if="subOrderType === 1"
            @click="showEditPhone = true"
            class="so-a-edit-btn"
            type="primary"
            slot="append"
          >
            编辑联系电话
          </el-button>
        </div>
      </div>
    </div>

    <!-- 商品信息 -->
    <div class="so-gdsi-w">
      <div class="od-table">
        <div class="od-t-name">
          <div class="n-h">商品信息</div>
          <div class="n-ct">
            <div class="od-t-n-l">
              <div class="od-t-img-w">
                <img
                  :src="
                    tImgUrl(
                      (goodsInfo.image && goodsInfo.image.split(',')[0]) || '',
                    )
                  "
                  alt=""
                  :onerror="errImgDefault"
                />
                <!-- <img v-else :src="errImgDefault" alt=""> -->
              </div>
            </div>
            <div class="od-t-n-r">
              <div class="od-t-title">
                {{ goodsInfo.name }}
              </div>
              <div
                class="od-d-child-goods"
                v-show="childGoods && childGoods.length"
              >
                <span>套餐组合名称:</span>
                {{ childGoods && childGoods[0].tczhmc }}
              </div>
              <div class="od-t-sub-title">
                {{ goodsInfo.intro }}
              </div>
            </div>
          </div>
        </div>
        <div class="od-t-price">
          <div class="pr-h">{{ subOrderType === 3 ? '兑换价' : '单价' }}</div>
          <div class="pr-ct" v-if="freeQuota === 1">
            {{ subOrderType === 1 ? '价格面议' : `0元` }}
          </div>
          <div class="pr-ct" v-else-if="subOrderType === 3">
            {{ goodsInfo.price }}
          </div>
          <div class="pr-ct" v-else>
            {{ subOrderType === 1 ? '价格面议' : `￥${goodsInfo.price}` }}
          </div>
        </div>
        <div class="od-t-count">
          <div class="c-h">数量</div>
          <div class="c-ct">
            <el-input-number
              :disabled="isVipTimesExchange"
              v-model="gdsNum"
              size="small"
              @change="numChg"
              :min="1"
              label=""
            ></el-input-number>
          </div>
        </div>
        <div class="od-t-point">
          <div class="p-h">
            {{
              subOrderType === 3
                ? '我的积分'
                : subOrderType === 2
                ? '商品积分'
                : '所获积分'
            }}
          </div>
          <div class="p-ct" v-if="subOrderType === 2">
            {{ goodsInfo.data && (goodsInfo.data.obtailPoint || 0) * gdsNum }}
          </div>
          <div class="p-ct" v-if="subOrderType === 3">{{ userInfo.point }}</div>
          <div class="p-ct" v-if="subOrderType === 1">
            {{ goodsInfo.data && (goodsInfo.data.obtailPoint || 0) * gdsNum }}
          </div>
        </div>
        <div class="od-t-total">
          <div class="t-h">小计</div>
          <div class="t-ct" v-if="freeQuota === 1">
            {{ subOrderType === 1 ? '价格面议' : `0元` }}
          </div>
          <div class="t-ct" v-else-if="subOrderType !== 3">
            {{
              subOrderType === 1
                ? '价格面议'
                : `￥${(goodsInfo.price * gdsNum).toFixed(2)}`
            }}
          </div>
          <div class="t-ct" v-else>{{ goodsInfo.price * gdsNum }}</div>
        </div>
      </div>
      <!-- 在线支付 - 附加信息 -->
      <div class="addition-info" v-if="subOrderType === 2">
        <div class="adif-upper">
          <div class="rec-code-w" v-show="goodsInfo.popularizationStatus === 1">
            商品推荐码：
            <el-input
              placeholder="请输入6位推荐码"
              @blur="chkCodeTimeout"
              @input="chkCodeInputTimeout"
              size="mini"
              class="rec-code"
              v-model="recCode"
            ></el-input>
          </div>
          <el-checkbox
            v-if="invoiceCkShow && freeQuota !== 1"
            v-model="needInvoice"
          >
            <!-- 我要开<el-link type="primary" style="margin-bottom: 2px" @click.stop.prevent="showInvoice = true">发票</el-link> -->
            我要开发票
          </el-checkbox>
          <el-checkbox v-show="needTreatyChk" v-model="treatyCked">
            我已阅读并同意
            <el-link type="primary" @click.stop.prevent="showTreaty = true">
              《{{ goodsInfo.agreementTitle }}》</el-link
            >
          </el-checkbox>
        </div>
        <div class="adif-down" v-if="goodsInfo.popularizationStatus === 1">
          <el-link type="primary" @click.stop.prevent="agShow = true"
            >查看优惠说明</el-link
          >
        </div>
      </div>
      <!-- 在线支付 - 价格面议 -->
      <div class="addition-info" v-if="subOrderType === 1">
        <div class="adif-upper">
          <div class="rec-code-w" v-show="goodsInfo.popularizationStatus === 1">
            商品推荐码：
            <el-input
              placeholder="请输入6位推荐码"
              @blur="chkCodeTimeout"
              @input="chkCodeInputTimeout"
              size="mini"
              class="rec-code"
              v-model="recCode"
            ></el-input>
          </div>
        </div>
        <div class="adif-down" v-if="goodsInfo.popularizationStatus === 1">
          <el-link type="primary" @click.stop.prevent="agShow = true"
            >查看优惠说明</el-link
          >
        </div>
      </div>
      <!-- 非在线、积分 -->
      <div class="treaty-info" v-if="subOrderType !== 2 && needTreatyChk">
        <el-checkbox v-model="treatyCked">
          我已阅读并同意
          <el-link type="primary" @click.stop.prevent="showTreaty = true"
            >《{{ goodsInfo.agreementTitle }}》</el-link
          >
        </el-checkbox>
      </div>
      <!-- 价格 -->
      <div class="so-handle">
        <div class="so-hb-h-w">
          <div class="discount-info" v-if="subOrderType === 2">
            <!--  1. VIP免费次数兑换商品不显示折扣
                  2.商品自身有折扣discountPrice != -1显示折扣
                  3.输入推荐码有效且discountPrice != -1显示折扣
            -->
            <div
              v-if="
                (goodsInfo.discountPrice !== -1 || codeDiscountWorks) &&
                !isVipTimesExchange
              "
            >
              商品折扣：-{{
                getValidPrice((goodsInfo.price - uniPrice) * gdsNum)
              }}
            </div>
            <!-- <div>可获积分：{{ (goodsInfo && goodsInfo.data && goodsInfo.data.obtailPoint) ?  goodsInfo.data.obtailPoint : 0 * this.gdsNum}}</div> -->
            <div v-if="recCodePoint > 0">
              可获积分：{{ recCodePoint * gdsNum }}
            </div>
          </div>
          <div class="s_order">
            <div class="hb-txt-w" v-if="!isVipTimesExchange">
              应付总额：{{ finalFee }}
            </div>
            <div class="hb-txt-w" v-else-if="isVipTimesExchange">
              应付总额：0.00元
            </div>
            <div>
              <!-- 必须要有价格才能对公转账 -->
              <!--            <el-button-->
              <!--              v-if="goodsInfo.price && subOrderType !== 1"-->
              <!--              @click="submitOrder('transferAccounts')"-->
              <!--              class="so-hb-btn"-->
              <!--              type="success">-->
              <!--              对公转账-->
              <!--            </el-button>-->
              <el-button @click="submitOrder" class="so-hb-btn" type="primary">
                提交订单
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑地址Dialog -->
    <el-dialog
      :close-on-click-modal="false"
      class="so-dia-add"
      ref="editDialog"
      width="50%"
      :open="beforeAdsEdit"
      :visible.sync="showEditAdd"
      :before-close="handleClose"
    >
      <div class="so-e-header" slot="title">编辑收货地址</div>
      <!-- form -->
      <div class="so-form-w">
        <el-form
          ref="addForm"
          :model="addForm"
          label-position="right"
          label-width="100px"
        >
          <el-row>
            <el-col :span="12">
              <div class="so-f-item">
                <el-form-item
                  label="收货人"
                  class="u-pwd-auth-c"
                  prop="name"
                  :rules="rule.consignee"
                >
                  <el-input
                    placeholder="请输入收货人"
                    v-model="addForm.name"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="so-f-item">
                <el-form-item
                  label="手机号码"
                  class="u-pwd-phone"
                  prop="phone"
                  :rules="rule.phone"
                >
                  <el-input
                    placeholder="请输入手机号码"
                    v-model="addForm.phone"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div class="so-f-item">
                <el-form-item
                  label="地区"
                  class="u-pwd-auth-c"
                  prop="region"
                  :rules="reginValidator"
                >
                  <el-cascader
                    ref="tgLocCas"
                    style="width: 100%"
                    v-model="addForm.region"
                    :props="{ checkStrictly: true }"
                    :options="locaOptions"
                    @change="getAreaTxtLo"
                  ></el-cascader>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="so-f-item">
                <el-form-item
                  label="详细地址"
                  class="u-pwd-auth-c"
                  prop="address"
                  :rules="rule.addressDetail"
                >
                  <el-input
                    placeholder="请输入详细地址"
                    v-model="addForm.address"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="so-e-footer">
        <el-button
          style="width: 40%"
          class="btn"
          type="primary"
          @click="subAddChg"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑手机号Dialog -->
    <el-dialog
      :close-on-click-modal="false"
      class="so-dia-pho"
      ref="editDialog"
      width="24%"
      :visible.sync="showEditPhone"
      :before-close="handleClose"
    >
      <div class="so-e-header" slot="title">修改手机号</div>
      <!-- form -->
      <div class="so-form-w">
        <el-form
          ref="phoneForm"
          :model="phoneForm"
          label-position="right"
          label-width="80px"
        >
          <div class="tp-f-item">
            <el-form-item
              label="手机号码"
              class="u-pwd-phone"
              prop="phone"
              :rules="rule.phone"
            >
              <el-input
                placeholder="请输入手机号码"
                v-model="phoneForm.phone"
              ></el-input>
            </el-form-item>
          </div>
          <div class="tp-f-item">
            <el-form-item
              label="验证码"
              class="u-pwd-auth-c"
              prop="authCode"
              :rules="rule.required"
            >
              <auth-code
                :phoneNum="phoneForm.phone"
                :isReg="false"
                v-model="phoneForm.authCode"
                @authCodeChange="setNewAuthCode"
              ></auth-code>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="so-e-footer">
        <el-button
          style="width: 40%"
          class="btn"
          type="primary"
          @click="subPhoChg"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <!-- 购买协议 -->
    <el-dialog
      class="so-treaty-dia"
      ref="treatyDialog"
      width="550px"
      :visible.sync="showTreaty"
      :before-close="handleClose"
    >
      <div class="so-e-header" slot="title">
        {{ goodsInfo.agreementTitle }}
      </div>
      <div class="treaty-txt" v-html="goodsInfo.agreementDetail"></div>
    </el-dialog>
    <!-- <agreement cateId="12" @agrShowHandler="agrShowHandler" :agShow="agShowPurchase" /> -->
    <agreement cateId="9" @agrShowHandler="agrShowHandler" :agShow="agShow" />
    <invoice-info
      ref="invoiceInfo"
      @savedInvoceInfo="savedInvoceInfo"
      :show="showInvoice"
      @visibleUpdate="visibleUpdate"
    ></invoice-info>
  </div>
</template>

<script>
import API from '@/api/api'
import rule from '@/util/rule'
import { areaData, getAreaTxtComma } from '@/util/area'
import { mapGetters } from 'vuex'
import AuthCode from '@/components/auth-code'
import InvoiceInfo from '@/components/invoice-info'
import Agreement from '@/components/agreement'

export default {
  props: {},
  data() {
    return {
      recCodePoint: 0,
      // 提交订单类型
      // 非在线支付（修改手机号码，价格面议）1
      // 在线支付（推荐码、发票）2
      // 积分商品（收货地址）3
      // subOrderType: 1,
      agShow: false,
      agShowPurchase: false,
      // 1
      freeQuota: 1,
      showEditPhone: false,
      phoneForm: {
        phone: '',
        authCode: '',
      },
      addForm: {
        name: '',
        phone: '',
        areaCode: [],
        address: '',
      },
      // 2
      recCode: '',
      needInvoice: false,
      showInvoice: false,

      // 3
      showEditAdd: false,
      addInfo: {},

      locaOptions: [],

      // all
      subBtnDis: false,
      goodsInfo: {},
      gdsNum: 1,
      treatyCked: false,
      showTreaty: false,
      invoiceCkShow: true,
      codeDiscountWorks: false,
      discountUnitPrice: -1,
      // form
      rule,
      areaTxt: '',
      reginValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('地区不能为空'))
          } else if (value.length !== 3) {
            return cb(new Error('请选择省-市-区'))
          } else {
            cb()
          }
        },
      },
      childGoods: [], //子商品数据
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'memberInfo']),
    finalFee() {
      return this.subOrderType === 1
        ? '价格面议'
        : this.subOrderType === 2
        ? `${(this.uniPrice * this.gdsNum).toFixed(2)}元`
        : `${this.uniPrice * this.gdsNum}`
    },
    subOrderType() {
      if (this.goodsInfo) {
        // 非在线 -- 1  1211611414083432450
        // 在线支付  --  2 1206808738074324993
        // 积分商品 -- 3 1214421359090753537
        return this.goodsInfo.type === 3
          ? 3
          : this.goodsInfo.isOnPay === 1
          ? 2
          : 1
      } else {
        return -1
      }
    },
    isVipTimesExchange() {
      return this.freeQuota === 1
    },
    uniPrice() {
      return this.codeDiscountWorks
        ? this.discountUnitPrice
        : this.getFinalPrice()
    },
    needTreatyChk() {
      return (
        this.goodsInfo &&
        this.goodsInfo.agreementDetail &&
        this.goodsInfo.agreementDetail !== ''
      )
    },
  },
  created() {
    this.initData()
    this.locaOptions = this._.cloneDeep(areaData)
    this.getChildGoods()
  },
  mounted() {
    this.initAddForm()
  },
  activated() {
    this.freeQuota = Number(this.$route.params.freeQuota)
  },
  deactivated() {},
  watch: {
    finalFee(newVal) {
      this.invoiceCkShow = newVal !== '0.00元'
      if (newVal === '0.00元') {
        this.needInvoice = false
      }
      // if (newVal === '0.00元') {
      //   this.invoiceCkShow = false
      // }
    },
    needInvoice(v) {
      if (!v) {
        delete this.goodsInfo.invoiceInfo
      } else {
        const vm = this
        // vm.showInvoice = true
        this._chkCode(function () {
          vm.showInvoice = true
        })
      }
    },
  },
  methods: {
    agrShowHandler(v) {
      this.agShow = v
    },
    savedInvoceInfo(ivInfo) {
      this.goodsInfo.invoiceInfo = ivInfo
      this.showInvoice = false
      console.log('发票信息：')
      console.log(ivInfo)
    },
    getFinalPrice() {
      return this.goodsInfo &&
        this.goodsInfo.discountPrice &&
        this.goodsInfo.discountPrice === -1
        ? this.goodsInfo.price
        : this.goodsInfo.discountPrice
    },
    async initAddForm() {
      // this.addForm = {
      //   name: '',
      //   address: '',
      //   phone: '',
      //   areaCode: '',
      //   region: []
      // }
      const addRe = await API.getAddress(this.memberInfo.id)
      // if (addRe.data.statusCode === '200') {
      //   this.addInfo = addRe.data.result
      //   this.addForm = {
      //     name: this.addInfo.receivingName,
      //     address: this.addInfo.address,
      //     phone: this.addInfo.mobile,
      //     areaCode: this.addInfo.areaCode,
      //     region: [this.addInfo.provinceCode, this.addInfo.cityCode, this.addInfo.areaCode]
      //   }
      // }
      if (!addRe.data.result || addRe.data.result === {}) {
        // this.addForm = {
        //   name: (this.memberInfo && this.memberInfo.username) || '',
        //   phone: (this.memberInfo && this.memberInfo.mobile) || '',
        //   region: [(this.userInfo && this.userInfo.provinceCode) || '', (this.userInfo && this.userInfo.cityCode) || '', (this.userInfo && this.userInfo.areaCode) || ''],
        //   address: (this.memberInfo && this.memberInfo.address) || '',
        //   areaCode: ''
        // }
        // this.addInfo = {
        //   memberId: this.memberInfo.id,
        //   provinceCode: (this.userInfo && this.userInfo.provinceCode) || '',
        //   cityCode: (this.userInfo && this.userInfo.cityCode),
        //   areaCode: (this.userInfo && this.userInfo.areaCode) || '',
        //   address: (this.memberInfo && this.memberInfo.address) || '',
        //   mobile: (this.memberInfo && this.memberInfo.mobile) || '',
        //   receivingName: (this.memberInfo && this.memberInfo.username) || '',
        //   region: [(this.userInfo && this.userInfo.provinceCode) || '', (this.userInfo && this.userInfo.cityCode) || '', (this.userInfo && this.userInfo.areaCode) || '']
        // }
        this.addForm = {
          name: this.addInfo.receivingName,
          address: this.addInfo.address,
          phone: this.addInfo.mobile,
          areaCode: this.addInfo.areaCode,
          region: [
            this.addInfo.provinceCode,
            this.addInfo.cityCode,
            this.addInfo.areaCode,
          ],
        }
        this.addInfo = {
          memberId: this.memberInfo.id,
          provinceCode: '',
          cityCode: '',
          areaCode: '',
          address: '',
          mobile: '',
          receivingName: '',
          region: [],
        }
      } else {
        this.addInfo = addRe.data.result
        this.addForm = {
          name: this.addInfo.receivingName,
          address: this.addInfo.address,
          phone: this.addInfo.mobile,
          areaCode: this.addInfo.areaCode,
          region: [
            this.addInfo.provinceCode,
            this.addInfo.cityCode,
            this.addInfo.areaCode,
          ],
        }
      }
    },
    beforeAdsEdit() {
      // console.log('ffffff')
      // this.$refs.addForm.setFields({
      //   name: this.memberInfo.username || '',
      //   phone: this.memberInfo.mobile || '',
      //   areaCode: [this.memberInfo.provinceCode, this.memberInfo.cityCode, this.memberInfo.areaCode],
      //   address: this.memberInfo.address || ''
      // })
    },
    // 获取联级节点值
    getAreaTxtLo(v) {
      this.$refs.addForm.validateField('region') // 验证地区
    },
    async initData() {
      // get goodsInfo
      const gdsRe = await API.getPrdDetail(this.$route.params.prodId)
      if (gdsRe.data.statusCode === '200') {
        this.goodsInfo = gdsRe.data.result
        // 线下支付商品获取手机号
        if (this.subOrderType === 1) {
          this.getReceivingMobile()
        }
      } else {
        this.$message({
          message: gdsRe.data.message,
          type: 'error',
        })
      }
    },

    async getReceivingMobile() {
      const moRes = await API.getReceivingMobile()
      if (moRes.data.statusCode === '200') {
        this.addInfo.mobile = moRes.data.result || ''
        // this.userInfo.mobile = moRes.data.result || ''
      } else {
        this.$message({
          message: moRes.data.message,
          type: 'error',
        })
      }
    },

    // 1
    setNewAuthCode(newVal) {
      this.phoneForm.authCode = newVal
    },
    subPhoChg() {
      this.$refs.phoneForm.validate(async (valid) => {
        if (valid) {
          this.phoneLoading = true
          const res = await API.addReceivingMobile({
            code: this.phoneForm.authCode,
            receivingMobile: this.phoneForm.phone,
          })
          if (res.data.statusCode === '200') {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.showEditPhone = false
            this.initData()
          } else {
            this.$message({
              message: res.data.message,
              type: 'warning',
            })
          }
        }
      })
    },

    //
    async submitOrder() {
      if (this.subOrderType === 3) {
        this._submit()
        return
      }
      // 验证推荐码
      if (!(await this._chkCode())) {
        return
      }
      // 验证文本协议
      if (!this._chkOrder()) {
        return
      }
      this._submit()
    },
    subAddChg() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          // console.log({
          //   address: this.addForm.address,
          //   areaCode: this.addForm.areaCode[2],
          //   cityCode: this.addForm.areaCode[1],
          //   provinceCode: this.addForm.areaCode[0],
          //   memberId: this.memberInfo.id,
          //   mobile: this.addForm.mobile,
          //   receivingName: this.addForm.name,
          //   region: this.areaTxt
          // })
          this.$loading = true
          let res = await API.addAddress({
            address: this.addForm.address,
            areaCode: this.addForm.region[2],
            cityCode: this.addForm.region[1],
            provinceCode: this.addForm.region[0],
            memberId: this.memberInfo.id,
            mobile: this.addForm.phone,
            receivingName: this.addForm.name,
            region: getAreaTxtComma(this.addForm.region),
          })
          this.$loading = false
          if (res.data.statusCode === '200') {
            setTimeout(() => {
              this.showEditAdd = false
              this.$message({
                message: res.data.message,
                type: 'success',
              })
              setTimeout(() => {
                this.initData()
                this.initAddForm()
              }, 300)
            }, 300)
          } else {
            this.$message(res.data.message)
          }
        }
      })
    },
    checkReceivingInfo() {
      // 积分商品需填写收货人、手机号和地址
      // 线下企业服务、线下培训需要填手机号
      let text = ''
      if (this.subOrderType === 3) {
        if (!this.addInfo.receivingName || this.addInfo.receivingName === '') {
          text = '请填写收货人'
          this.$message({
            message: text,
            type: 'warning',
          })
          return false
        } else if (!this.addInfo.mobile || this.addInfo.mobile === '') {
          text = '请填写收货人手机号'
          this.$message({
            message: text,
            type: 'warning',
          })
          return false
        } else if (!this.addInfo.address || this.addInfo.address === '') {
          text = '请填写收货人地址'
          this.$message({
            message: text,
            type: 'warning',
          })
          return false
        }
      } else if (this.subOrderType === 1) {
        if (!this.addInfo.mobile || this.addInfo.mobile === '') {
          text = '请填写收货人手机号'
          this.$message({
            message: text,
            type: 'warning',
          })
          return false
        }
      }
      return true
    },
    async _submit() {
      if (!this.checkReceivingInfo()) {
        return
      }
      let subParams = this.transformParams(
        {
          id: this.userInfo.id,
          receivingMobile: this.addInfo.mobile,
          receivingAddress:
            this.subOrderType === 1
              ? ''
              : `${this.addInfo.region},${this.addInfo.address}`,
          receivingName:
            this.subOrderType === 1
              ? this.userInfo.username
              : this.addInfo.receivingName,
        },
        this.goodsInfo,
        {
          gdsNum: this.gdsNum,
          subOrderType: this.subOrderType,
          addForm: this.addInfo,
          referralCode: this.recCode,
          isVipTimesExchange: Number(!this.isVipTimesExchange), // 是否viP免费次数兑换：0是 1否
        },
        this.uniPrice * this.gdsNum,
      )
      // 给subParams添加套餐分组参数
      subParams.tczhid = this.childGoods.length ? this.childGoods[0].tczhid : ''
      subParams.tczhmc = this.childGoods.length ? this.childGoods[0].tczhmc : ''
      // console.log(subParams)
      // let skph = sessionStorage.getItem('skph')
      // let nsrsbh = sessionStorage.getItem('nsrsbh')
      // if (skph) {
      //   subParams.skph = skph
      // }
      // if (nsrsbh) {
      //   subParams.nsrsbh = nsrsbh
      // }
      const subRe = await API.subOrder(subParams)
     
      // alert(subRe.data.statusCode)
      if (subRe.data.statusCode === '200') {
        // if (subRe.data.result.qr && subRe.data.result.qr !== '') {
        //   // 这种情况是线上直接支付成功，价格为0元的情况，会直接跳转到支付成功界面
        //   this.$router.push({
        //     name: 'payResult',
        //     query: {
        //       payState: 1,
        //       orderNumber: subRe.data.result.orderNumber,
        //       goodsName: subRe.data.result.goodsName,
        //       qr: subRe.data.result.qr || ''
        //     }
        //   })
        //   return
        // }
        // 更新订单消息条数
        setTimeout(() => {
          this.$store.dispatch('getUnreadCount')
        }, 2000)

        if (Number(!this.isVipTimesExchange) === 0) {
          // 用会员免费兑换名额下单的订单直接跳转到订单成功页面
          this.$router.push({
            name: 'payResult',
            query: {
              payState: 1,
              orderNumber: subRe.data.result.orderNumber,
              goodsName: subRe.data.result.goodsName,
              qr: subRe.data.result.qr || '',
              tip: subRe.data.result.msg,
            },
          })
          // this.$router.push({
          //   name: 'payResult',
          //   query: {
          //     orderId: subRe.data.result.orderId,
          //     orderNumber: subRe.data.result.orderNumber
          //   },
          //   params: {
          //     exChgRe: subRe.data.result,
          //     type: 1
          //   }
          // })
          return
        }
        if (subRe.data.result.isOnPay) {
          // if (type === 'transferAccounts') {
          //   // 对公转账方式
          //   const data = await API.transferAccounts({
          //     orderNumber: subRe.data.result.orderNumber,
          //     status: 12  // 对公转账标识  9已关闭 11已确认对公 12未确认对公
          //   })
          //   this.$message.success('提交成功，请核对组核对')
          //   return
          // }
          // 线上需要通过扫描二维码支付
          this.$router.push({
            name: 'payQRCode',
            query: {
              orderId: subRe.data.result.orderId,
              orderNumber: subRe.data.result.orderNumber,
              tip: subRe.data.result.msg,
              payUrl: subRe.data.result.payUrl, //聚合支付
            },
            params: {
              exChgRe: subRe.data.result,
            },
          })
        } else {
          // 线下支付的线下培训商品，通过qr来判断是否是线下培训
          if (subRe.data.result.qr) {
            this.$router.push({
              name: 'payResult',
              query: {
                payState: 1,
                orderNumber: subRe.data.result.orderNumber,
                goodsName: subRe.data.result.goodsName,
                qr: subRe.data.result.qr || '',
                tip: subRe.data.result.msg,
              },
            })
            return
          }

          // 积分支付的积分商品，直接扣减积分后跳转到扣减积分成功页面
          this.$router.push({
            name: 'result',
            query: {
              orderId: subRe.data.result.orderId,
              orderNumber: subRe.data.result.orderNumber,
            },
            params: {
              exChgRe: subRe.data.result,
              type: this.subOrderType,
            },
          })
        }
      } else {
        let _self = this
        // this.subBtnDis = false
        this.$message({
          message: subRe.data.message + `稍后为您自动跳转...`,
          type: 'warning',
        })
        // 5秒跳转到个人信息界面
        setTimeout(() => {
          _self.$router.push(`/userInfo`)
        }, 5000)
        // time=setInterval(() => {
        //   subSeconds--
        //   if(subSeconds==1){
        //     _self.$router.push(`/userInfo`)
        //     clearInterval(time)
        //     time=null
        //   }
        // }, 1000);
      }
    },
    handleClose(done) {
      done()
    },
    handleChange(v) {
      this.areaCodeArr = v
    },
    numChg() {},
    chkCodeTimeout(f) {
      setTimeout(() => {
        this._chkCode(f)
      }, 100)
    },
    chkCodeInputTimeout() {
      if (this.recCode.trim() === '') {
        this.recCode = this.recCode.trim()
        this.codeDiscountWorks = false
        this.recCodePoint = 0
        // console.log('xxxxxxxxxxx')
        return true
      }
    },
    async _chkCode(f) {
      if (this.recCode.trim() === '') {
        this.recCode = this.recCode.trim()
        this.codeDiscountWorks = false
        this.recCodePoint = 0
        if (f && typeof f === 'function') {
          console.log(f)
          f()
        }
        return true
      }
      let loading = this.$loading({ fullscreen: true })
      try {
        let res = await API.getRecdInfo({
          goodsId: this.$route.params.prodId,
          code: this.recCode,
        })
        if (res.data.statusCode === '200') {
          this.recCodePoint = res.data.result.popularizationDeductionPoint || 0
          if (res.data.result.discountPrice === -1) {
            this.codeDiscountWorks = false
          } else {
            this.codeDiscountWorks = true
            this.discountUnitPrice = res.data.result.discountPrice
          }

          if (
            res.data.result.discountPrice !== 0 &&
            f &&
            typeof f === 'function'
          ) {
            console.log('dazhe')
            f()
          }
          // this.discountUnitPrice = (res.data.result.discountPrice === -1) ? res.data.result.price : res.data.result.discountPrice
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loading.close()
          })
          return true
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.recCode = ''
        this.codeDiscountWorks = false
        this.recCodePoint = 0
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loading.close()
        })
        return false
      }
    },
    _chkOrder() {
      // if (this.goodsInfo.agreementDetail !== '' && !this.treatyCked) {
      if (this.needTreatyChk && !this.treatyCked) {
        this.$alert('您还未同意购买协议')
        return false
      }
      if (this.needInvoice && !this.$refs.invoiceInfo.validateForm()) {
        console.log('submit2')
        this.$alert('发票信息填写有误，请检查')
        return false
      }
      console.log('submit3')
      return true
    },
    visibleUpdate(b) {
      this.showInvoice = b
      if (!b) {
        this.needInvoice = false
      }
    },
    getChildGoods() {
      this.childGoods =
        sessionStorage.getItem('childGoods') &&
        JSON.parse(sessionStorage.getItem('childGoods'))
      console.log('子数据', this.childGoods)
      if (this.childGoods) {
        // 把tczhid变回json格式字符串
        this.childGoods[0].tczhid = JSON.stringify(this.childGoods[0].tczhid)
        console.log(this.childGoods)
      }
    },
    // 对公转帐
    async transferAccounts() {
      // 验证推荐码
      if (!(await this._chkCode())) {
        return
      }
      // 验证文本协议
      if (!this._chkOrder()) {
        return
      }
      if (!this.checkReceivingInfo()) {
        return
      }
      let subParams = this.transformParams(
        {
          id: this.userInfo.id,
          receivingMobile: this.addInfo.mobile,
          receivingAddress:
            this.subOrderType === 1
              ? ''
              : `${this.addInfo.region},${this.addInfo.address}`,
          receivingName:
            this.subOrderType === 1
              ? this.userInfo.username
              : this.addInfo.receivingName,
        },
        this.goodsInfo,
        {
          gdsNum: this.gdsNum,
          subOrderType: this.subOrderType,
          addForm: this.addInfo,
          referralCode: this.recCode,
          isVipTimesExchange: Number(!this.isVipTimesExchange), // 是否viP免费次数兑换：0是 1否
        },
        this.uniPrice * this.gdsNum,
      )
      // 给subParams添加套餐分组参数
      subParams.tczhid = this.childGoods.length ? this.childGoods[0].tczhid : ''
      subParams.tczhmc = this.childGoods.length ? this.childGoods[0].tczhmc : ''
      const subRe = await API.subOrder(subParams)
    },
  },
  components: {
    AuthCode,
    InvoiceInfo,
    Agreement,
  },
}
</script>

<style lang="stylus">
.so-o-w {
  width: 1200px;
  margin: auto;

  .so-address-w {
    .so-a-title {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 0px;
      color: #666666;
      border-bottom: 1px solid #ddd;
      margin-bottom: 10px;
    }

    .so-a-info {
      background-color: #ffffff;
      padding: 20px 30px;
      display: flex;

      .so-a-l {
        max-width: 70%;
        flex: 1 1 auto;
        color: #999999;
        font-size: 15px;

        .add-item {
          word-break: break-all;
          white-space: normal;
          height: auto;
          width: 100%;
          font-size: 16px;
          line-height: 40px;
        }

        .phone-item {
          font-size: 16px;
          height: 60px;
          line-height: 60px;
        }
      }

      .so-a-r {
        flex: 0 0 360px;
        center();
      }
    }
  }

  .so-gdsi-w {
    margin-top: 20px;

    .od-table {
      color: #777777;
      display: flex;

      [class$='-h'] {
        height: 40px;
        center();
      }

      [class$='-ct'] {
        height: 130px;
        background-color: #ffffff;
        center();
        // border-right: 2px solid #f1f1f1;
        border-bottom: 2px solid #f1f1f1;
        padding: 20px 0;
        box-sizing: border-box;
      }

      .od-t-name {
        flex: 4 4 auto;

        .n-ct {
          display: flex;
          padding: 20px 30px;

          > div {
            height: 100px;
          }

          .od-t-n-l {
            flex: 0 0 160px;
            // background-color green
            overflow: hidden;
            margin-right: 20px;

            .od-t-img-w {
              goods-img-wrapper();

              img {
                goods-img-image();
              }
            }
          }

          .od-t-n-r {
            flex: 1 1 auto;

            .od-t-title {
              max-width: 450px;
              max-height: 50px;
              font-size: 20px;
              line-height: 26px;
              color: #333333;
              margin: 6px 0px 10px;
            }

            .od-d-child-goods {
              margin-bottom: 10px;
            }

            .od-t-sub-title {
              overflow: hidden;
              line-height: 26px;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 450px;
              width: 100%;
            }
          }
        }
      }

      .od-t-price {
        flex: 1.5 1.5 auto;
      }

      .od-t-count {
        flex: 1 1 auto;
      }

      .od-t-point {
        flex: 1 1 auto;
      }

      .od-t-total {
        flex: 1 1 auto;
      }
    }
  }

  .treaty-info {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #dddddd;
  }

  .addition-info {
    // border-bottom: 1px solid #dddddd;
    padding-bottom: 10px;

    .adif-upper, .adif-down {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;

      .rec-code-w {
        width: 270px;
        display: inline-block;

        .rec-code {
          width: 130px;
        }
      }
    }
  }

  .so-handle {
    flex-right();
    height: 170px;

    .so-hb-h-w {
      columnCenter();

      .discount-info {
        > div {
          height: 32px;
          line-height: 32px;
        }
      }

      .hb-txt-w {
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: orange-color;
      }

      .so-hb-btn {
        width: 150px;
        margin-left: 30px;
      }
    }
  }

  .so-dia-add {
    .so-e-footer {
      center();
    }
  }

  .so-dia-pho {
    .so-e-footer {
      center();
    }
  }

  .so-treaty-dia {
    .treaty-txt {
      line-height: 30px;
      font-size: 18px;
    }
  }
}

.s_order {
  display: flex;
  align-items: center;
}

.n-h, .pr-h, .c-h, .p-h, .t-h {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #666666;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.n-h {
  justify-content: left !important;
}
</style>
